<script setup>
import { usePlatformConfigurationStore } from '@/stores/platform_configuration';

const platformConfigurationStore = usePlatformConfigurationStore();

const is_chat_enabled = process.env.VUE_APP_CHAT_ENABLED == 'true';
const show_whatsapp_on_header = platformConfigurationStore.showWhatsappOnHeader;

const unlockTawkBodyLock = () => {
	const body = document.body;
	const html = document.documentElement;

	body.style.removeProperty('position');
	body.style.removeProperty('top');
	body.style.removeProperty('left');
	body.style.removeProperty('right');
	body.style.removeProperty('width');
	body.style.removeProperty('height');
	body.style.removeProperty('min-height');
	body.style.removeProperty('max-height');
	body.style.removeProperty('max-width');
	body.style.removeProperty('overflow');

	html.style.removeProperty('overflow');

	if (location.hash === '#max-widget') {
		history.replaceState(null, document.title, location.pathname + location.search);
	}
};

const openChat = () => {
	const y = window.scrollY || window.pageYOffset || 0;

	document.activeElement?.blur?.();

	window.Tawk_API?.toggle?.();

	const fix = () => {
		unlockTawkBodyLock();
		window.scrollTo(0, y);
	};

	requestAnimationFrame(fix);
	setTimeout(fix, 50);
	setTimeout(fix, 200);
};

const openWhatsapp = () => {
	window.open(show_whatsapp_on_header, '_blank');
};

</script>

<template>
	<img style="cursor:pointer;" v-if="usePlatformConfigurationStore().isLiveChatHeader && is_chat_enabled" @click.prevent="openChat" src="/assets/images/livechat_icon.svg"  width="30" height="30"  viewBox="0 0 25.207 25.207"/>

	<img style="cursor:pointer;" v-if="show_whatsapp_on_header" @click.prevent="openWhatsapp" src="/assets/images/wa_icon.svg"  width="25" height="25"  viewBox="0 0 25.207 25.207"/>
</template>